export function debounce(func, delay = 400) {
    let timer;
    return function (data) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(data);
        }, delay)
    }
}